import { Box } from '@mui/material';
import { ContainedModal } from 'components/molecules';
import { PetSymptoms } from 'components/molecules/pet/PetSymptoms';
import { useTreatmentOnGoing } from 'context';
import React from 'react';

export const PetRiskClassificationModal: React.FC = () => {
  const { treatmentOnGoing, riskClassificationModal } = useTreatmentOnGoing();

  if (!treatmentOnGoing?.id) {
    return null;
  }

  const { symptoms, generalClassification } = treatmentOnGoing;

  return (
    <ContainedModal
      isOpen={riskClassificationModal.isOpen}
      onClose={riskClassificationModal.onClose}
      title="TRIAGEM"
    >
      <Box px={3}>
        <PetSymptoms
          symptoms={symptoms}
          generalClassification={generalClassification}
        />
      </Box>
    </ContainedModal>
  );
};
